/** Apna Caledon 65" TV giveaway — public campaign config */

export const GIVEAWAY_EVENT_SLUG = "apna-caledon-2026";

/** Emergency kill switch only — live on/off is Admin → Giveaway toggle (API). */
export const GIVEAWAY_CAMPAIGN_HARD_OFF =
  process.env.REACT_APP_GIVEAWAY_ENABLED === "false";

export const GIVEAWAY_PATH = `/giveaway/${GIVEAWAY_EVENT_SLUG}`;

export const GIVEAWAY_BANNER_LABEL = '🎉 Apna Caledon — Win a 65" TV! Enter now →';
